import styled from "styled-components";
import { CloseOutlined } from "@ant-design/icons";
import { ThemePalette } from "../../../theme";
export interface ImportTabProps {
  disabled: boolean;
}

export const Home = styled.img`
  background-color: ${ThemePalette.colorBlack};
  padding: 0 1rem;
  cursor: pointer;
`;

export const StyledProjectMenu = styled.div<{ isEditMode?: boolean }>`
  --horizontal-padding: 2rem;

  color: ${ThemePalette.colorWhite};
  backdrop-filter: blur(70px);
  background-size: cover;
  padding: 0.7rem 0.75rem;
  background: ${({ isEditMode }) =>
    isEditMode ? "rgba(54, 1, 40, 0.89)" : "transparent"};
  ${({ isEditMode }) =>
    isEditMode &&
    "backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);"}
  transition: background 0.3s ease;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .top-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 100%;

    .menu-container {
      display: flex;
      align-items: center;
      :hover {
        border-radius: 6px;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        color: white;
        background-color: rgb(255 255 255 / 0.15);
      }
    }

    .image-logo {
      width: 5rem;
      cursor: pointer;
    }

    .project-heading {
      font-weight: semi-bold;
      cursor: pointer;
      padding: 0.5rem 0.3rem;
      transition: all 0.3s;
    }
  }
  .nav-items {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }
  .nav-items:hover {
    color: white;
    background-color: rgb(255 255 255 / 0.15);
  }

  .top-header-right {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: flex-end;
    width: 100%;
  }

  .navigation-bar {
    position: relative;
    display: flex;
    .project-menu-button {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      cursor: pointer;
    }


    nav {
      padding: 1rem var(--horizontal-padding);
      display: flex;
      background: linear-gradient(
        to bottom,
        ${ThemePalette.colorPrimaryGradientFromLight} 10%,
        ${ThemePalette.colorPrimaryGradientToLight} 90%
      );
      backdrop-filter: blur(1rem);
      transition: top 0.5s ease;

      &.active {
        margin: 0;
        top: 0;
        left: 0;
        display: flex;
        transition: top 0.5s ease;
        transform: translateY(3.9rem);
      }

      ol {
        padding: 0 0;
        list-style-type: none;
        padding: unset;

        li {
          a {
            text-decoration: none;
            color: ${ThemePalette.colorWhite};
          }
          padding: 0.5rem;
        }
        .nav-item {
          display: flex;
          a {
            text-decoration: none;
            color: ${ThemePalette.colorWhite};
          }
          padding: 0.5rem;
        }
      }

      .default-navigation {
        padding-right: 0;
      }

      .project-menu-navigation {
        li {
          display: inline-block;
          padding: 0.5rem;
        }
      }
    }
  }
  .no-sheets {
    padding: 1rem var(--horizontal-padding);
    padding-left: 3rem;
    color: #9f9f9f;
  }
  h1 {
    cursor: pointer;
  }

  .searchInput{
    background-color: red !important;
  }
`;
export const OrderedList = styled.ol`
  width: fit-content;
`;
export const Message = styled.p<{
  margin?: string;
  marginBottom?: string;
}>`
  margin: ${(props) => props.margin};
  margin-bottom: ${(props) => props.marginBottom};
`;
export const UserIcon = styled.div`
  cursor: pointer;
  position: absolute;
  top: 2rem;
  right: 0;
  transform: translateY(-50%);
  font-size: small;
  img {
    height: 4rem;
    width: 4rem;
  }
`;

export const AdditionalTabs = styled.div`
  display: flex;
  justify-content: self-end;
  gap: 1rem;
  padding: 0.3rem;
  background-color: rgb(255 255 255 / 0.15);
  border-radius: 6px;
  cursor: pointer;
  .nav-items {
    padding: 0.2rem 0.35rem;
  }
`;

export const VersionTab = styled.div`
  background-color: ${ThemePalette.colorPrimaryLight};
  padding: 0.2rem 0.35rem;
  border-radius: 6px;
`;
export const FilterTab = styled.img`
  background-color: ${ThemePalette.colorPrimaryGradientToLight};
  padding: 1rem;
`;
export const ImportTab = styled.div<ImportTabProps>`
  input[type="file"] {
    display: none;
  }

  .custom-file-upload {
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  }
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`;

export const ExportTab = styled.div<ImportTabProps>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`;

export const SaveTab = styled.div<ImportTabProps>`
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`;

export const AddRowTab = styled.div<ImportTabProps>`
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`;

export const EditOnlineTab = styled.div<ImportTabProps>`
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  background: #F26522;
  color: #ffffff;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.2s;
  &:hover { background: #e05a1c; }
`;

export const CancelTab = styled.div<ImportTabProps>`
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`;

export const SidebarContainer = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 3.8rem;
  right: 0;
  width: 250px;
  height: 95vh;
  padding: 1rem var(--horizontal-padding);
  /* background: linear-gradient(
    to bottom,
    ${ThemePalette.colorPrimaryGradientFromLight} 10%,
    ${ThemePalette.colorPrimaryGradientToLight} 90%
  ); */
  background-color: ${ThemePalette.colorWhite};
  border: 1px solid ${ThemePalette.colorPrimary};
  backdrop-filter: blur(1rem);
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
  transform: ${(props) =>
    props.isVisible ? "translateX(0)" : "translateX(100%)"};
  opacity: ${(props) => (props.isVisible ? "1" : "0")};
  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  /* z-index: 1000; */
`;

export const StyledClose = styled(CloseOutlined)`
  margin-right: auto;
  color: ${ThemePalette.colorGray};
  transition:
    transform 0.2s ease,
    color 0.2s ease;
  &:hover {
    transform: scale(1.1);
    color: black;
  }
`;
export const SidebarContent = styled.div`
  flex: 1;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: hidden;

  .filter-header {
    font-size: 1.2rem;
    height: 3.5rem;
    padding: 1rem;
    /* margin: 2rem; */
    color: ${ThemePalette.colorWhite};
    text-align: left;
    justify-content: flex-start;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    background-color: ${ThemePalette.colorPrimary};
  }

  .filter-description {
    margin: 2rem 1rem;
    text-align: left;
    color: ${ThemePalette.colorGrayDark};
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  padding: 0;
  margin: 0;
  align-items: flex-end;
  justify-content: center;
  gap: 1rem;
  margin: -5rem 0 1rem 0;
`;
export const SidebarButton = styled.button`
  background-color: ${ThemePalette.colorPrimary};
  color: ${ThemePalette.colorWhite};
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 4px;
`;
export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: flex-start;
  margin-left: 2rem;
  /* margin-top: 5rem; */
  /* overflow-y: auto; */
  height: 20rem;
  font-size: 0.8rem;
  color: ${ThemePalette.colorGrayDark};

  input {
    outline: 0.06rem solid ${ThemePalette.colorPrimary};
    border-radius: 0.2rem;
    top: 1.2rem;
    width: 14rem;
    left: -0.8rem;
    padding: 0 0.5rem;
    border: none;
    font-size: 1rem;
    background-color: ${ThemePalette.colorWhite};
    /* gap:2rem; */
  }
`;
